import { NavLink } from 'react-router-dom'
import { useApp } from '@/context/AppContext'

// ── Inline SVG icons ─────────────────────────────────────────────────────────
const HomeIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor" strokeWidth={filled ? 0 : 2} className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M3 12l9-9 9 9M4 10v10a1 1 0 001 1h5v-5h4v5h5a1 1 0 001-1V10" />
  </svg>
)

const CalendarIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor" strokeWidth={filled ? 0 : 2} className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
)

const ChatIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor" strokeWidth={filled ? 0 : 2} className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
)

const MsgIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor" strokeWidth={filled ? 0 : 2} className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
)

// Documents tab — was a hamburger placeholder, now a real document glyph.
const MoreIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor" strokeWidth={filled ? 0 : 2} className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round"
      d="M9 13h6m-6 4h6m2 4H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
)

const nav = [
  { to: '/dashboard',        label: 'Home',      Icon: HomeIcon     },
  { to: '/calendar',         label: 'Calendar',  Icon: CalendarIcon },
  { to: '/ask',              label: 'Ask AI',    Icon: ChatIcon     },
  { to: '/direct-messages',  label: 'Messages',  Icon: MsgIcon      },
  { to: '/documents',        label: 'Documents', Icon: MoreIcon     },
]

export default function BottomNav() {
  const { directMsgCount } = useApp()

  return (
    <nav
      className={[
        'bottom-nav flex-shrink-0',
        'flex items-stretch bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800 shadow-nav',
        'lg:justify-center lg:gap-2 lg:px-4 lg:py-2',
      ].join(' ')}
      aria-label="Main navigation"
    >
      {nav.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            [
              'flex-1 flex flex-col items-center justify-center gap-1 py-2 min-h-[62px] relative',
              'transition-colors duration-150 select-none tap-target',
              'lg:flex-none lg:min-w-[118px] lg:rounded-xl lg:px-4 lg:py-3',
              isActive
                ? 'text-brand-700'
                : 'text-slate-500 dark:text-slate-400 hover:text-brand-600 lg:hover:bg-slate-50 dark:lg:hover:bg-slate-800',
            ].join(' ')
          }
        >
          {({ isActive }) => (
            <>
              <div className="relative">
                <Icon filled={isActive} />
                {to === '/direct-messages' && directMsgCount > 0 && (
                  <span
                    className="absolute -top-2 -right-3 text-[9px] font-bold px-1.5 py-px rounded-full text-white select-none pointer-events-none"
                    style={{
                      background: 'linear-gradient(145deg, #ff5a5a 0%, #e00 60%, #b00 100%)',
                      boxShadow: '0 1px 4px rgba(180,0,0,0.5), inset 0 1px 1px rgba(255,255,255,0.35)',
                      textShadow: '0 1px 1px rgba(0,0,0,0.25)',
                      letterSpacing: '0.05em',
                    }}
                  >
                    NEW
                  </span>
                )}
              </div>
              <span className="text-xs lg:text-sm font-semibold tracking-wide">{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
